// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import { put, call, takeEvery } from 'redux-saga/effects';

import { privacyPolicyService } from './service';
import * as privacyPolicyActions from './actions';
import * as types from './actionTypes';

function* privacyPolicySaga() {
  const res = yield call(privacyPolicyService);
  if (res.ok) {
    const result = res.body.items[0];
    const { title } = result;
    let { paragraphs } = result;
    paragraphs = paragraphs.map((el) => {
      return {
        title: el.title,
        text: el.text,
      };
    });
    yield put(privacyPolicyActions.requestPageDataSuccess({
      title,
      paragraphs,
    }));
  }
}

const privacyPolicySagas = [
  takeEvery(types.PP_REQUEST_PAGE_DATA, privacyPolicySaga),
];

export default privacyPolicySagas;
